import type { VoidFunctionComponent } from 'react';

import { OrganizationSsoMethod } from '../../../../../../../typings/enums';
import { useAuthenticationSettingsContext } from '../../hooks';
import CheckEmailModal from '../CheckEmailModal';
import MultiStepsClaimDomainModal from '../MultiStepsClaimDomainModal';

type Props = {
  isOpen: boolean;
  onHide: () => void;
};

const ClaimDomainModal: VoidFunctionComponent<Props> = ({ isOpen, onHide }) => {
  const { location } = useAuthenticationSettingsContext();
  const { samlAuthenticated: samlAuthenticatedDomain } = location?.query || {};

  if (samlAuthenticatedDomain) {
    return <CheckEmailModal isOpen={isOpen} onHide={onHide} domain={samlAuthenticatedDomain} />;
  }

  return <MultiStepsClaimDomainModal isOpen={isOpen} onHide={onHide} method={OrganizationSsoMethod.SAML} />;
};

export default ClaimDomainModal;
